module.exports = __webpack_public_path__ + "booking-header-img.a7d44ba6.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/Booking/booking-header-img.jpg
// module id = 609
// module chunks = 0